<template>
  <div class="PopUpPict">
    <div class="PopUpFon" @click="hide"></div>
    <div class="PhotoShow"
      :style="{ 'background-image': `url(${picture.picture})` }"
      @click="hide"
    ></div>
    <div class="PhotoTxt">{{ picture.title }}</div>
  </div>
</template>

<script>
export default {
  props: {
    picture: { type: Object, default: function() { return {}; } },
    hide: Function
  },
};
</script>
